package com.eladfinish.bible.contest.screens.mikud.usecases

import com.eladfinish.bible.contest.screens.mikud.model.BookState
import com.eladfinish.bible.contest.screens.mikud.model.BookSummaryModel
import com.eladfinish.bible.contest.screens.mikud.model.MikudSummaryModel
import com.eladfinish.bible.contest.utils.addGershaim
import com.eladfinish.bible.contest.utils.toOtiot

class BuildMikudSummaryUseCase {

    operator fun invoke(mikudState: List<BookState>): MikudSummaryModel {
        val books = mikudState
            .filter { it.isNotEmpty() }
            .map { book ->
                val chaptersText = book.chapters
                    .withIndex()
                    .filter { it.value }
                    .joinToString(separator = ", ", postfix = ".\n") { (index, _) ->
                        (index + 1).toOtiot().addGershaim()
                    }

                BookSummaryModel(
                    name = book.name,
                    includedChaptersCount = book.includedChaptersCount,
                    chaptersText = chaptersText,
                )
            }

        return MikudSummaryModel(
            totalChapters = mikudState.sumOf { it.includedChaptersCount },
            books = books,
        )
    }
}
